import { Grid, Card, CardContent, Typography } from '@mui/material';

export const PracticeAreas = () => {
    const practiceAreas = [
        {
            title: 'Immobilienrecht',
            description: 'Beratung und Vertretung beim Kauf und Verkauf von Immobilien, Grundstücksrecht, Grundbuchangelegenheiten sowie rechtliche Begleitung von Immobilienprojekten.'
        },
        {
            title: 'Mietrecht',
            description: 'Rechtsberatung und Vertretung in privaten und gewerblichen Mietverhältnissen, einschließlich Kündigung, Mängel, Mieterhöhung und Räumung.'
        },
        {
            title: 'Bau- und Architektenrecht',
            description: 'Unterstützung bei Bau- und Architektenverträgen, Mängelansprüchen, Vergütungsfragen sowie Konflikten zwischen Bauherren, Unternehmern und Planern.'
        },
        {
            title: 'Verkehrsrecht',
            description: 'Rechtliche Beratung bei Verkehrsunfällen, Schadensregulierung, Führerscheinangelegenheiten sowie Ansprüchen auf Schadensersatz und Schmerzensgeld.'
        },
        {
            title: 'Arbeitsrecht',
            description: 'Beratung und Vertretung bei Kündigungen, Abmahnungen, Arbeitsverträgen, Zeugnisfragen und weiteren arbeitsrechtlichen Streitigkeiten.'
        },
        {
            title: 'Kaufrecht',
            description: 'Unterstützung bei Kaufverträgen, Sach- und Rechtsmängeln, Rücktritt, Minderung sowie der Durchsetzung von Gewährleistungsansprüchen.'
        },
        {
            title: 'Strafrecht & Verkehrsstrafrecht',
            description: 'Strafverteidigung in allgemeinen Strafsachen sowie in Verkehrsstrafsachen, einschließlich Ordnungswidrigkeiten, Bußgeldverfahren und Fahrverboten.'
        },
        {
            title: 'Gewerberecht',
            description: 'Beratung von Unternehmen und Selbstständigen zu gewerberechtlichen Fragen, Genehmigungen, Auflagen und Auseinandersetzungen mit Behörden.'
        },
        {
            title: 'Vertragsgestaltung und Mediation',
            description: 'Gestaltung und Prüfung von Verträgen sowie außergerichtliche Konfliktlösung durch Mediation zur nachhaltigen und effizienten Streitbeilegung.'
        }
    ]
    return (
        <>
            <Typography
                variant="overline"
                color="text.secondary"
            >
                Übersicht unserer Rechtsgebiete
            </Typography>
            <Grid container spacing={4}>
                {practiceAreas.map((area, idx) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} key={idx}>
                        <Card
                            elevation={1}
                            sx={{
                                height: '100%',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: 4,
                                },
                                borderRadius: 2,
                                border: '1px solid #e0e0e0',
                            }}
                        >
                            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
                                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: '#222' }}>
                                    {area.title}
                                </Typography>
                                <Typography variant="body2" textAlign={"justify"} sx={{ color: '#555', lineHeight: 1.5, textJustify: "inter-character", hyphens: "auto" }}>
                                    {area.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </>
    )

}